import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    next: 'Submit my PIN code',
    sidebarImgAlt: 'Confirm the PIN code for your card',
    subtitle:
      'Set your secure code to validate your operations with this card.',
    title: 'Confirm the PIN code for your card',
  },
  fr: {
    next: 'Valider mon code PIN',
    sidebarImgAlt: 'Confirmez votre code PIN',
    subtitle:
      'Définissez votre code sécurisé pour valider vos opérations avec cette carte.',
    title: 'Confirmez votre code PIN',
  },
} as const);

export default locales;
